import { shape, string } from 'prop-types';

const getServiceDisplayName = (service) => {
  switch (service.id) {
    case 'MOVING':
      return 'Complete home move';
    case 'LOADINGUNLOADING':
      return 'Moving labor';
    case 'LDLOADING':
    case 'LOADING':
      return 'Loading';
    case 'LDUNLOADING':
    case 'UNLOADING':
      return 'Unloading';
    case 'LDTRANSIT':
    case 'TRANSIT':
      return 'Truck & Driver';
    case 'HOURLYLABOR':
      return 'Hourly Labor';
    default:
      return service.name;
  }
};

getServiceDisplayName.propTypes = {
  service: shape({
    id: string,
    name: string,
  }),
};

export default getServiceDisplayName;
